/**
 * AI Agents / BizAI permission keys (must match backend / profile API).
 */
export const AI_AGENTS_PERMISSIONS = {
    /** Company + role: module tab, Agents / Plans pages. */
    viewModule: 'can_view_ai_agents',
    /** Role: create / edit / delete agents and sub-agents. */
    manageAgents: 'can_manage_ai_agents',
    /** Role (+ company if assigned): floating BizAI assistant. */
    useAssistant: 'can_use_ai_assistant',
    /** Role: view plans and usage. */
    viewPlansUsage: 'can_view_ai_agents_plans_usage',
} as const;

export type AiAgentsPermissionKey = keyof typeof AI_AGENTS_PERMISSIONS;
